const CONVERSION_FACTOR = 0.621371;
export const kilometersToMiles = (kilometers: number) => kilometers * CONVERSION_FACTOR;
export const milesToKilometers = (miles: number) => miles / CONVERSION_FACTOR;
